import { render, staticRenderFns } from "./CreateDealDocsTemplate.vue?vue&type=template&id=0a96ed18&scoped=true"
import script from "./CreateDealDocsTemplate.vue?vue&type=script&lang=js"
export * from "./CreateDealDocsTemplate.vue?vue&type=script&lang=js"
import style0 from "./CreateDealDocsTemplate.vue?vue&type=style&index=0&id=0a96ed18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a96ed18",
  null
  
)

export default component.exports